import { css } from '@emotion/css';

export const swatchStyles = css`
  white-space: nowrap;

  &::before {
    content: ' ';
    display: inline-block;
    width: 1em;
    height: 1em;
    border: 1px solid rgba(128, 128, 128, 0.3);
    vertical-align: middle;
    margin-inline-end: 0.1em;
    margin-bottom: 0.15em;
    border-radius: 2px;
    background-color: var(--swatch-color);
  }
`;
